define("settings/components/section/item-action", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--section__action" ...attributes>
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{#if (and @buttonRoute @buttonText)}}
        <LinkTo class="o--btn o--btn--outline u--m__r {{@buttonStyles}}" @route={{@buttonRoute}}>
          {{@buttonText}}
        </LinkTo>
      {{/if}}
      {{#if (and @buttonExternalRoute @buttonText)}}
        <LinkToExternal class="o--btn o--btn--outline u--m__r {{@buttonStyles}}" @route={{@buttonExternalRoute}}>
          {{@buttonText}}
        </LinkToExternal>
      {{/if}}
    {{/if}}
  </div>
  
  */
  {
    "id": "OhT3Z6pg",
    "block": "[[[11,0],[24,0,\"tAC--section__action\"],[17,1],[12],[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"    \"],[18,6,null],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,2],[30,3]],null],[[[1,\"      \"],[8,[39,4],[[16,0,[29,[\"o--btn o--btn--outline u--m__r \",[30,4]]]]],[[\"@route\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[41,[28,[37,3],[[30,5],[30,3]],null],[[[1,\"      \"],[8,[39,5],[[16,0,[29,[\"o--btn o--btn--outline u--m__r \",[30,4]]]]],[[\"@route\"],[[30,5]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]]],[13],[1,\"\\n\"]],[\"&attrs\",\"@buttonRoute\",\"@buttonText\",\"@buttonStyles\",\"@buttonExternalRoute\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"and\",\"link-to\",\"link-to-external\"]]",
    "moduleName": "settings/components/section/item-action.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});